import styled from 'styled-components';

const Container = styled.div`
  width: auto;
  margin: 0 auto;
  position: relative;
  flex-grow: 1;
`;

export default Container;